import parse from 'html-react-parser';
import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Modal, Tab } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";

import DeleteIcon from '@mui/icons-material/Delete';
import ButtonMUI from '@mui/material/Button';
import axios from "axios";
import { FaEdit } from "react-icons/fa";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { toast } from 'react-toastify';
import swal from "sweetalert";
import QuestionSampleFile from '../../../download_files/Question_Sample_Files.docx';
import { BACKEND_SERVER_URL } from "../../../http/http-config";
import './QuestionBank.css';

import { Stack } from "@mui/material";
import { fetchSubTestData, formateSubTestData } from "../TestManagement/TestHelper";
import { getTestQuestions, setQuestionBoxStyling } from "./questionBankService";
import QuestionModal from "./QuestionModal";
const QuestionBank = () => {
    const navigate = useNavigate();
    const childRef = useRef();

    const { state } = useLocation();
    console.log('state', state)
    const packageId = state?.packageId;
    const testSeriesSn = state?.testSeriesSn;

    console.log(packageId, testSeriesSn)

    // const { testId } = useParams();

    const [selectedQuestionNumber, setSelectedQuestionNumber] = useState(1);
    const [testData, setTestData] = useState({});
    console.log(testData)

    const [testQuestions, setTestQuestions] = useState([]);
    const [testExistedQuestions, setTestExistedQuestions] = useState([]);
    console.log(testExistedQuestions)
    const [existedQuestionNumbers, setExistedQuestionNumbers] = useState([]);
    const [correctAnswer, setCorrectAnswer] = useState('');
    const [selectedQuestion, setSelectedQuestion] = useState({});
    const [showQuestion, setShowQuestion] = useState(false);
    const [loadQuestions, setLoadQuestions] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");

    const handleSearchQuestion = () => {
        const qNum = parseInt(searchQuery, 10);
        if (isNaN(qNum) || qNum <= 0) {
            toast.error("Please enter a valid question number");
            return;
        }
        if (qNum > testData.questionCount) {
            toast.error(`Question number must be between 1 and ${testData.questionCount}`);
            return;
        }
        setSelectedQuestionNumber(qNum);
    };
    //console.log(selectedQuestion, selectedQuestionNumber, showQuestion)
    const [modalBox, setModalBox] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null);

    useEffect(() => {
        fetchSubTestData(packageId).then((test) => {
            formateSubTestData(test).then(formatedData => {
                if (formatedData.title) {
                    setTestData(formatedData)
                    let emptyArray = new Array(formatedData.questionCount).fill({}).map((emptyObj, index) => ({ questionNumber: index + 1, isQuestionExisted: false }))
                    setTestQuestions(emptyArray)

                }
            })
        })
    }, [])
    console.log(testData)

    useEffect(() => {
        if (testData.sn) {
            getTestQuestions(testData.packageId, testSeriesSn).then(res => {
                setTestExistedQuestions(res)
                let questionNumbers = res.map(question => question.questionNumber)
                setExistedQuestionNumbers([...new Set(questionNumbers)])
                setTestQuestions(testQuestions.map(question => {
                    return {
                        ...question,
                        isQuestionExisted: questionNumbers.includes(question.questionNumber) ? true : false
                    }
                }))
            }
            ).catch(error => {
                console.log(error)
            })
        }
    }, [testData, loadQuestions])

    useEffect(() => {
        console.log('enter')
        let selectedQ = testExistedQuestions?.find(question => question.questionNumber == selectedQuestionNumber)
        if (selectedQ?.questionNumber) {
            setSelectedQuestion(selectedQ)
            setCorrectAnswer(selectedQ?.correctAnswer?.toLowerCase())
            setShowQuestion(true)
        } else {
            setSelectedQuestion({})
            setShowQuestion(false)
        }

    }, [selectedQuestionNumber, testExistedQuestions])


    function handleUploadFile() {
        toast.info("Question paper file is being proccessed, It will take 1 minute to save quetions")
        setModalBox(false)
        let formData = new FormData();
        formData.append('uploadedFile', selectedFile, selectedFile.name);
        //  formData.append('totalQuestions', totalQuestoins);   
        console.log(formData)
        axios.post(BACKEND_SERVER_URL + `/uploadQuestions/${packageId}`, formData)
            .then((response) => {
                if (response.data.statusCode == 200) {
                    toast.success(response.data.message);
                }
                setLoadQuestions(!loadQuestions)
            })
            .catch(error => {
                toast.error(error.response.data.message);
            });
    }
    console.log(selectedFile)

    const handleDeleteQuestion = (sn) => {
        swal({
            title: "Are you sure?",
            text: `Once deleted, you will not be able to recover this Question2`,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            console.log(BACKEND_SERVER_URL + '' + sn)
            if (willDelete) {
                axios.post(BACKEND_SERVER_URL + `/hideQuestion/${sn}/${testSeriesSn}`).then((res) => {
                    if (res) {
                        swal(`Poof! Your Question has been deleted!`, {
                            icon: "success",
                        });
                        setLoadQuestions(!loadQuestions);
                    }
                }).catch(error => {
                    console.log(error.response.data)
                    toast.error(error.response.data.message)
                })
            }
        })
    }
    return (
        <Fragment >
            <div className="card p-0 rounded-0 mb-0 ps-0">
                <div className="row gx-0 ">
                    <div className=" bg-light " style={{ flex: 2 }}>
                        <div style={{ backgroundColor: "#f4f5f6" }}>
                            <ButtonMUI disabled={!testData.courseId} className="ms-2 mt-2 mb-2" variant="outlined" color="secondary" startIcon={<SlArrowLeft size={10} />} onClick={() => navigate('/test-lists', { state: { courseId: testData?.courseId, testSeriesSn } })} >
                                Back
                            </ButtonMUI>
                        </div>
                        <div className="px-2 mt-2">
                            <div className="input-group">
                                <input 
                                    type="number" 
                                    className="form-control form-control-sm" 
                                    placeholder="Search Q.No..." 
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    onKeyDown={(e) => { if (e.key === 'Enter') handleSearchQuestion(); }}
                                />
                                <button className="btn btn-primary btn-sm" onClick={handleSearchQuestion}>
                                    Search
                                </button>
                            </div>
                        </div>
                        {/* <button className=" w-75 ms-4 mt-2 btn btn-info btn-xs " onClick={() => setModalBox(true)}> Import Quetions</button> */}
                        <div className="email-left-box dlab-scroll pt-2" >
                            <div className="col-sm-12 mt-0">
                                <div className="row d-flex  justify-content-start ">
                                    {testQuestions?.map((questionBoxData) => (
                                        <div className="col-1 m-1 ms-3 rounded-circle text-center cursor-pointer"
                                            style={setQuestionBoxStyling(questionBoxData, selectedQuestionNumber)}
                                            onClick={() => setSelectedQuestionNumber(questionBoxData.questionNumber)}
                                        >
                                            {questionBoxData.questionNumber}
                                        </div>
                                    ))
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="" style={{ flex: 10 }}>
                        <div className="email-right-box ">
                            {<Tab.Container defaultActiveKey="Import">
                                <div role="toolbar" className="toolbar ms-1 ms-sm-0 ">
                                    <div className="saprat " style={{ backgroundColor: "#f4f5f6" }}>
                                        <div className="col-2 m-auto  ms-0">
                                            <h4 className="ps-3"> Question: {selectedQuestionNumber}</h4>
                                        </div>
                                        <div className="col-10 m-auto ms-0 ">
                                            <h4 className=''>
                                                <span style={{ fontWeight: 'bold' }}>
                                                    TEST NAME :{" "}
                                                </span>
                                                <span style={{ textDecoration: 'underline', color: 'green' }}>
                                                    {testData?.title && testData.title.length > 50 ? `${testData.title.slice(0, 65)}...` : testData.title}
                                                </span>
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-12 col-xxl-12 col-lg-12 ">
                                    <div className="card h-auto">
                                        <div className="card-footer p-2">
                                            <div className="row d-flex justify-content-between">
                                                <div className="d-flex justify-content-between">
                                                    <ButtonMUI variant="outlined" color="secondary" startIcon={<SlArrowLeft size={10} />} onClick={() => setSelectedQuestionNumber(selectedQuestionNumber - 1)}
                                                        disabled={selectedQuestionNumber == 1}>
                                                        Previous
                                                    </ButtonMUI>
                                                    <ButtonMUI variant="outlined" color="success" endIcon={<SlArrowRight size={10} />} onClick={() => setSelectedQuestionNumber(selectedQuestionNumber + 1)} disabled={selectedQuestionNumber == testData?.questionCount}>
                                                        Next
                                                    </ButtonMUI>
                                                </div>
                                            </div>
                                        </div>
                                        {(showQuestion) ? <div className="card-body pt-0 ">
                                            <div className="question-bank-styling " style={{ color: 'black' }}>
                                                {/*  <p className="heading text-dark">Question: {" " + selectedQuestionNumber} </p> */}
                                                <div className="d-flex ps-2 ">
                                                    <div>  <span className={` ps-2 `}>{selectedQuestion.question ? parse(selectedQuestion.question) : null}</span> </div>
                                                </div>

                                                <div className="d-flex " style={{ display: 'flex' }}>
                                                    <strong className={`${correctAnswer == 'a' && 'bg-success text-white'}`}> (A)</strong>
                                                    <span className={` ps-2 ${correctAnswer == 'a' && 'bg-success text-white'}`}> {selectedQuestion.option1 ? parse(selectedQuestion.option1) : null} </span>
                                                </div>
                                                <div className="d-flex " style={{ display: 'flex' }}>
                                                    <strong className={`${correctAnswer == 'b' && 'bg-success text-white'} `}>(B)</strong>
                                                    <span className={` ps-2 ${correctAnswer == 'b' && 'bg-success text-white'}`}>{selectedQuestion.option2 ? parse(selectedQuestion.option2) : null}</span>
                                                </div>
                                                <div className="d-flex " style={{ display: 'flex' }}>
                                                    <strong className={`${correctAnswer == 'c' && 'bg-success text-white'} `}>(C)</strong>
                                                    <span className={` ps-2 ${correctAnswer == 'c' && 'bg-success text-white'}`}>{selectedQuestion.option3 ? parse(selectedQuestion.option3) : null}</span>
                                                </div>
                                                <div className="d-flex" style={{ display: 'flex' }}>
                                                    <strong className={`${correctAnswer == 'd' && 'bg-success text-white'} `}>(D)</strong>
                                                    <span className={` ps-2 ${correctAnswer == 'd' && 'bg-success text-white'}`}>{selectedQuestion.option4 ? parse(selectedQuestion.option4) : null}</span>
                                                </div>

                                                <div className="d-flex" style={{ display: 'flex' }}>
                                                    <strong >Explanation: </strong>
                                                    <span className={` ps-2 `}>{selectedQuestion?.description ? parse(selectedQuestion?.description) : null}</span>
                                                </div>

                                            </div>
                                        </div> :
                                            <div className="card-body m-auto">
                                                <button type="button" className="btn btn-dark btn-sm"
                                                    onClick={() => childRef.current.openModal(testSeriesSn, testData.packageId, selectedQuestionNumber, {})}
                                                >
                                                    + Add Question
                                                </button>
                                            </div>

                                        }
                                        {showQuestion && <div className="card-footer">
                                            <div className="row d-flex justify-content-between">
                                                <div className="col-md-3 d-flex justify-content-between">
                                                    <Stack direction="row" spacing={2}>
                                                        <ButtonMUI variant="outlined" color="error" startIcon={<DeleteIcon />} onClick={() => handleDeleteQuestion(selectedQuestion.sn)}>
                                                            Delete
                                                        </ButtonMUI>
                                                        <ButtonMUI variant="outlined" color="primary" endIcon={<FaEdit />} onClick={() => childRef.current.openModal(testSeriesSn, testData.packageId, selectedQuestionNumber, selectedQuestion)}>
                                                            Edit
                                                        </ButtonMUI>
                                                    </Stack>
                                                </div>
                                                <div className="col-md-3 d-flex justify-content-between">
                                                    <Stack direction="row" spacing={2}>
                                                        <ButtonMUI variant="outlined" color="secondary" startIcon={<SlArrowLeft size={10} />} onClick={() => setSelectedQuestionNumber(selectedQuestionNumber - 1)}
                                                            disabled={selectedQuestionNumber == 1}>
                                                            Previous
                                                        </ButtonMUI>
                                                        <ButtonMUI variant="outlined" color="success" endIcon={<SlArrowRight size={10} />} onClick={() => setSelectedQuestionNumber(selectedQuestionNumber + 1)} disabled={selectedQuestionNumber == testData?.questionCount}>
                                                            Next
                                                        </ButtonMUI>
                                                    </Stack>
                                                </div>
                                            </div>
                                        </div>
                                        }
                                    </div>

                                </div>
                            </Tab.Container>
                            }
                        </div>
                    </div>

                </div>
            </div>
            <Modal onHide={setModalBox} show={modalBox} centered>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Import Question file</h5>
                        <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3 d-block">
                            <a href={QuestionSampleFile} download="question_sample_file.docx" ><Button variant="outline-info" size='sm' title='Click here to download the sample file'>Download Sample file </Button> </a>
                        </div>
                        <div className="mb-3 d-block">
                            <label htmlFor="basic-url" className="form-label d-block">Upload file</label>
                            <input type="file" className="form-control w-100" onChange={(e) => setSelectedFile(e.target.files[0])} accept=".docx" placeholder="upload file" />
                            {selectedFile == null ? < p className='text-danger'>Please select file</p> : null}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                        <button type="button" className="btn btn-primary btn-xs" onClick={handleUploadFile}>Upload file</button>
                    </div>
                </div>
            </Modal >

            <QuestionModal ref={childRef} setLoadQuestions={setLoadQuestions} loadQuestions={loadQuestions} />
        </Fragment >

    );
};

export default QuestionBank;

